import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	// `wrap`: en pantallas estrechas o con zoom, los botones bajan de línea en vez de salirse por la derecha (doc 0447, D8).
	contactsHeader: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		rowGap: 4,
		padding: "0px 6px 6px 6px",
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.contactsHeader}>{children}</div>;
};

export default MainHeader;
